import { useMemo } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

// project-imports
import AppBarStyled from "./AppBarStyled";
import HeaderContent from "./HeaderContent";
import IconButton from "components/@extended/IconButton";
import GlobalSearch from "components/GlobalSearch";
import InlineGlobalSearch from "components/GlobalSearch/InlineGlobalSearch";
import { useGlobalSearch } from "hooks/useGlobalSearch";

import useConfig from "hooks/useConfig";
import { handlerDrawerOpen, useGetMenuMaster } from "api/menu";
import {
  DRAWER_WIDTH,
  MINI_DRAWER_WIDTH,
  ThemeMode,
} from "config";

// assets
import { HambergerMenu } from "iconsax-react";
import { Box } from "@mui/material";

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const theme = useTheme();
  const { open: searchOpen, setOpen: setSearchOpen } = useGlobalSearch();

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  const { mode } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  const iconBackColorOpen =
    mode === ThemeMode.DARK ? "background.paper" : "secondary.200";
  const iconBackColor =
    mode === ThemeMode.DARK ? "background.default" : "secondary.100";

  // common header
  const mainHeader = (
    <Toolbar sx={{ px: { xs: 2, sm: 4.5, lg: 8 } }}>
      <IconButton
        aria-label="open drawer"
        onClick={() => handlerDrawerOpen(!drawerOpen)}
        edge="start"
        color="secondary"
        variant="light"
        size="large"
        sx={{
          color: "secondary.main",
          bgcolor: drawerOpen ? iconBackColorOpen : iconBackColor,
          ml: { xs: 0, lg: -2 },
          p: 1,
        }}
      >
        <HambergerMenu />
      </IconButton>
      
      {/* Global Search Input */}
      <Box sx={{ 
        ml: { xs: 1, sm: 2 }, 
        flex: { xs: '0 0 auto', sm: '0 0 auto' }, 
        maxWidth: { xs: 'auto', sm: '500px' },
        display: 'flex',
        alignItems: 'center',
      }}>
        <InlineGlobalSearch 
          onFocus={() => setSearchOpen(true)}
          onClick={() => setSearchOpen(true)}
        />
      </Box>
      
      {headerContent}
      
      {/* Global Search Dialog */}
      <GlobalSearch open={searchOpen} onClose={() => setSearchOpen(false)} />
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: "fixed",
    elevation: 0,
    sx: {
      bgcolor: "rgba(255, 255, 255, 0.6)",
      // borderBottom: `1px solid #DBE0E5`,
      backdropFilter: "blur(20px)",        // blur effect
      WebkitBackdropFilter: "blur(10px)",  // Safari support

      zIndex: 1200,
      top: 0,
      width: {
        xs: "100%",
        lg: drawerOpen
          ? `calc(100% - ${DRAWER_WIDTH}px)`
          : `calc(100% - ${MINI_DRAWER_WIDTH}px)`,
      },
    },
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <>
          <AppBar {...appBar}>{mainHeader}</AppBar>
        </>
      )}
    </>
  );
}
